import 'bootstrap/dist/js/bootstrap.min';
import prestashop from 'prestashop';
import EventEmitter from 'events';
import $ from 'jquery';
import DropDown from './components/drop-down';
import Form from './components/form';
// import usePasswordPolicy from './components/usePasswordPolicy';
// import ProductMinitature from './components/product-miniature';
// import ProductSelect from './components/product-select';
// import TopMenu from './components/top-menu';
// import 'swiper/swiper-bundle.css';
// import './lib/bootstrap-filestyle.min';
// import './lib/jquery.scrollbox.min';
// import './components/block-cart';

import './components/search';
import './components/count-down-timer';
import {handleAddToCart} from './utils/add-to-cart';

$(document).on('click', '.add-to-cart-btn', (event) => {
  event.preventDefault();
  const button = event.currentTarget; // native DOM element
  const productId = button.getAttribute('data-product-id');
  const quantity = button.getAttribute('data-quantity') || 1;

  handleAddToCart(button, productId, quantity);
});

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

// $(document).ready(() => {
//   const dropDownEl = $('.js-dropdown');
//   const form = new Form();
//   const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
//   const dropDown = new DropDown(dropDownEl);
//   dropDown.init();
//   form.init();
//   topMenu.init();
//   productMinitature.init();
//   productSelect.init();
//   usePasswordPolicy('.field-password-policy');
// });
